import Logo from "@/assets/svg/full-logo/vvv-white.svg";
import scrollTo from "@/utils/scrollTo";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import QuickLinks from "../QuickLinks";
import SupportTicket from "../SupportTicket";

export default function VVVFooter() {
  const location = useLocation();
  const navigate = useNavigate();

  const [modalOpen, setModalOpen] = useState(false);

  const isHome = location.pathname === "/";
  const isEsign = location.pathname === "/esign";
  const isClips = location.pathname === "/submit-clips";

  const goUp = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleScrollTo = (targetPath, scrollId) => {
    if (location.pathname === targetPath) {
      scrollTo(scrollId);
    } else {
      navigate(targetPath, { state: { scrollTo: scrollId } });
    }
  };

  useEffect(() => {
    if (location.state?.scrollTo) {
      setTimeout(() => {
        scrollTo(location.state.scrollTo);
        navigate(location.pathname, { replace: true, state: {} });
      }, 100);
    }
  }, [location, navigate]);

  return (
    <div className="4xl:max-w-[100rem] 4xl:mx-auto">
      <div className="bg-[#141414] text-white p-10">
        <div className="flex flex-col gap-12 justify-center items-center">
          <img src={Logo} alt="VVV Logo" />
          <p className="text-white/50 max-w-xl text-center">
            Every viral moment starts somewhere — we find the internet’s most
            powerful videos, refine their storytelling, and share them across
            the world to inspire, entertain, and connect millions.
          </p>
          <div className="w-full flex flex-col lg:flex-row gap-6 lg:gap-20 justify-center text-center">
            {isHome ? (
              <p
                onClick={() => goUp()}
                className="cursor-pointer hover:underline"
              >
                Home
              </p>
            ) : (
              <Link to={"/"} className="cursor-pointer hover:underline">
                <p>Home</p>
              </Link>
            )}
            <p
              className="cursor-pointer hover:underline"
              onClick={() => handleScrollTo("/", "testimonials")}
            >
              Reviews
            </p>
            <p
              className="cursor-pointer hover:underline"
              onClick={() => handleScrollTo("/", "how-it-works")}
            >
              How it works
            </p>

            {isEsign ? (
              <p
                onClick={() => goUp()}
                className="cursor-pointer hover:underline"
              >
                Become a Distributor
              </p>
            ) : (
              <Link to="/esign" className="block">
                <p className="cursor-pointer hover:underline">
                  Become a Distributor
                </p>
              </Link>
            )}
            {isClips ? (
              <p
                onClick={() => goUp()}
                className="cursor-pointer hover:underline"
              >
                Submit a Clip
              </p>
            ) : (
              <Link to="/submit-clips" className="block">
                <p className="cursor-pointer hover:underline">Submit a Clip</p>
              </Link>
            )}
          </div>
          <QuickLinks setModalOpen={setModalOpen} />
          <p className="text-white/50">
            © 2025 VeryViralVideos. All Rights Reserved
          </p>
        </div>
      </div>
      <SupportTicket modalOpen={modalOpen} setModalOpen={setModalOpen} />
    </div>
  );
}
